import React from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  styled,
  tableCellClasses,
  MenuItem,
  Grid,
  Chip,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Select,
  SelectChangeEvent,
  Link,
  TableContainer,
} from "@mui/material";
import {
  useGetProductSectionItemsQuery,
  useGetProductWithSectionsMutation,
} from "../../redux/reducer/features/Product/productSlice";
import PageLoader from "../app/PageLoader";
import { useParams } from "react-router-dom";
import ScrollContainer from "react-indiana-drag-scroll";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import { Carousel } from "react-responsive-carousel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import "react-responsive-carousel/lib/styles/carousel.min.css";

// import { Image } from "semantic-ui-react";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ProductDetailPublicView: React.FunctionComponent = () => {
  let { productId } = useParams();
  const [selectedSection, setSelectedSection] = React.useState<any>();
  const [selectedPart, setSelectedPart] = React.useState<any>();
  const [viewPartOpen, setViewPartOpen] = React.useState(false);
  const [productSections, setProductSections] = React.useState<any[]>([]);
  const [product, setProduct] = React.useState<any>();
  const [productSectionItems, setProductSectionItems] = React.useState<any>();
  const [productByIdMutation, productByIdMutationResult] =
    useGetProductWithSectionsMutation();
  const {
    data: sectionItemsResult,
    isLoading,
    isSuccess,
    refetch: refetchSectionItems,
  } = useGetProductSectionItemsQuery(
    { productSectionId: selectedSection?.id },
    { skip: !selectedSection?.id }
  );
  // const [getProductSectionItemsMutation, getProductSectionItemsMutationResult] =
  //   useGetProductSectionItemsMutation();
  const [isOpen, setOpen] = React.useState(false);
  const [URL, setURL] = React.useState("");
  const [item, setItem] = React.useState<
    { id?: string; left: number; top: number }[]
  >([]);

  React.useEffect(() => {
    productByIdMutation({ data: { id: productId } });
  }, []);

  React.useEffect(() => {
    if (productByIdMutationResult.isSuccess && productByIdMutationResult.data) {
      setProduct(productByIdMutationResult.data?.entity);
      if (productByIdMutationResult.data?.entity?.productSections.length > 0) {
        setProductSections(
          productByIdMutationResult.data?.entity?.productSections
        );
        setSelectedSection(
          productByIdMutationResult.data?.entity?.productSections[0]
        );
      }
    }
  }, [productByIdMutationResult]);

  React.useEffect(() => {
    if (selectedSection) {
      refetchSectionItems();
    }
    console.log("Product sections", productSections);
  }, [selectedSection]);

  React.useEffect(() => {
    if (isSuccess && sectionItemsResult) {
      var data = sectionItemsResult?.entityList.map((item: any) => ({
        id: item.id,
        top: item.topPosition,
        left: item.leftPosition,
      }));
      setItem(data);
      setProductSectionItems(sectionItemsResult?.entityList);
    }
  }, [sectionItemsResult]);

  const handleLightBoxClose = () => {
    setOpen(false);
  };
  const handleClose = () => {
    setViewPartOpen(false);
  };

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedSection(
      productSections.find((item) => item.id === event.target.value)
    );
  };
  const handleIconClick = (item: any) => {
    console.log("Icon Click", item);
    setSelectedPart(item?.part);
    setViewPartOpen(true);
  };
  const handleSectionImage = () => {
    setURL(
      "https://digitalinnovationcaba96.blob.core.windows.net/product-catalog/ProductImage/" +
        selectedSection?.imgUrl
    );
    setOpen(true);
  };
  const handleSectionChange = (item: any) => {
    console.log("Section change call", item);
  };

  const CustomArrowPrev = ({
    onClick,
  }: {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  }) => (
    <button className="custom-arrow prev" onClick={onClick}>
      <ArrowBackIosIcon sx={{ fontSize: "2rem" }} />
    </button>
  );

  const CustomArrowNext = ({
    onClick,
  }: {
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  }) => (
    <button className="custom-arrow next" onClick={onClick}>
      <ArrowForwardIosIcon sx={{ fontSize: "2rem" }} />
    </button>
  );
  return (
    <>
      <div style={{ margin: 50 }}>
        <PageLoader isLoading={productByIdMutationResult.isLoading} />
        {/* <Card style={{ padding: "10px", margin: "10px" }}> */}
        <Box
          // sx={{ margin: "10px" }}
          display="flex"
          flexDirection="row"
          justifyContent="flex-start"
        >
          <img
            alt="Product Image"
            style={{ width: "180px", cursor: "pointer" }}
            onClick={() => {
              setURL(product?.images[0]?.absoluteUrl ?? "");
              setOpen(true);
            }}
            src={product?.images[0]?.absoluteUrl}
          ></img>{" "}
          <Typography color="primary" sx={{ ml: 3, fontSize: "25px" }}>
            {product?.title}

            <div style={{ fontSize: "12px", color: "black" }}>
              SKU:{product?.sku}
            </div>
          </Typography>
        </Box>
        <Grid mt={8} container>
          <Grid item md={1} />
          <Grid item md={10}>
            <Carousel
              renderArrowPrev={(onClickHandler, hasPrev, label) =>
                hasPrev && <CustomArrowPrev onClick={onClickHandler} />
              }
              renderArrowNext={(onClickHandler, hasNext, label) =>
                hasNext && <CustomArrowNext onClick={onClickHandler} />
              }
              showThumbs={false}
              swipeable={true}
              infiniteLoop={true}
              showIndicators={false}
              centerSlidePercentage={15}
              showArrows={true}
              centerMode={true}
            >
              {productSections.map((section: any) => {
                return (
                  <div
                    style={{
                      cursor: "pointer",
                      border:
                        selectedSection.id === section.id
                          ? "2px solid black"
                          : "0px",
                      width: "80%",

                      height: "80%",
                    }}
                    onClick={() => {
                      setSelectedSection(section);
                    }}
                  >
                    <img
                      src={
                        "https://digitalinnovationcaba96.blob.core.windows.net/product-catalog/ProductImage/" +
                        section?.imgUrl
                      }
                      style={{ width: "100%", height: "100%" }}
                    ></img>
                    <Typography color="primary" sx={{ fontSize: "10px" }}>
                      {section?.title}
                    </Typography>
                  </div>
                );
              })}
            </Carousel>
          </Grid>
          <Grid item md={1} />
        </Grid>
        <Box sx={{ mt: 4 }}>
          <Typography color="primary" sx={{ fontSize: "17px" }}>
            {selectedSection?.title}
          </Typography>
          {selectedSection && (
            <Select
              variant="standard"
              sx={{ width: "17%", fontSize: ".8rem" }}
              onChange={handleChange}
              defaultValue={selectedSection?.id}
              itemID="id"
            >
              {productSections
                ? productSections.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.title}
                    </MenuItem>
                  ))
                : ""}
            </Select>
          )}
        </Box>
        <Grid container sx={{ mt: 2 }}>
          <Grid item md={12}>
            <Link
              onClick={handleSectionImage}
              sx={{
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              View Diagram
            </Link>
          </Grid>
          <Grid item md={6}>
            <ScrollContainer
              style={{
                height: "66vh",
                overflow: "auto",
                border: "1px solid black",
                position: "relative",
                marginRight: 20,
                borderRadius: "4px",
              }}
            >
              <img
                alt="draggable"
                src={
                  "https://digitalinnovationcaba96.blob.core.windows.net/product-catalog/ProductImage/" +
                  selectedSection?.imgUrl
                }
                style={{ cursor: "pointer" }}
              ></img>
              {productSectionItems
                ? productSectionItems.map((n: any) => (
                    <>
                      <PanoramaFishEyeIcon
                        style={{
                          position: "absolute",
                          left: n.leftPosition,
                          top: n.topPosition,
                          width: "40px",
                          height: "40px",
                          color: "#63993ade",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          handleIconClick(n);
                        }}
                      />
                    </>
                  ))
                : ""}
            </ScrollContainer>
          </Grid>
          <Grid item md={6}>
            <Card>
              <TableContainer
                sx={{
                  height: "66vh",
                }}
              >
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: "#1976d2",
                          height: "max-content",
                          paddingTop: 1,
                          paddingBottom: 1,
                        }}
                      >
                        Sr.No
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          pl: 6,
                          color: "#1976d2",
                          paddingTop: 1,
                          paddingBottom: 1,
                        }}
                        align="left"
                      >
                        Title
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontWeight: "bold",
                          color: "#1976d2",
                          paddingTop: 1,
                          paddingBottom: 1,
                        }}
                      >
                        Description
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productSectionItems && productSectionItems.length > 0
                      ? productSectionItems
                          ?.slice()
                          .sort((a: any, b: any) => a.itemNumber - b.itemNumber)
                          .map((item: any, index: number) => (
                            <StyledTableRow>
                              <StyledTableCell
                                align="center"
                                component="th"
                                scope="row"
                                sx={{ padding: 0.5, fontSize: "12px" }}
                              >
                                <Typography
                                  sx={{
                                    ml: 2,
                                    fontSize: "12px",
                                  }}
                                >
                                  {item?.itemNumber}
                                </Typography>
                              </StyledTableCell>
                              <StyledTableCell
                                align="left"
                                sx={{ padding: 0.5 }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "flex-start",
                                    flexDirection: "row",
                                    alignItems: "center",
                                  }}
                                >
                                  {item.part?.images[0]?.url ? (
                                    <div
                                      style={{
                                        width: "25px",
                                        height: "30px",
                                        backgroundColor: "white",
                                        borderRadius: "0.25rem",
                                        border: "1px solid #DEE2E6",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setOpen(true);
                                        setURL(
                                          item.part?.images[0]?.absoluteUrl ??
                                            ""
                                        );
                                      }}
                                    >
                                      <img
                                        style={{
                                          width: "100%",
                                          height: "100%",
                                        }}
                                        alt=""
                                        src={
                                          item.part?.images[0]?.absoluteUrl ??
                                          ""
                                        }
                                      ></img>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <Typography
                                    sx={{
                                      ml: 2,
                                      fontSize: "12px",
                                    }}
                                  >
                                    {item?.part?.title}
                                  </Typography>
                                </Box>
                              </StyledTableCell>
                              <StyledTableCell
                                sx={{ padding: 0.5, fontSize: "12px" }}
                                align="left"
                              >
                                <Typography
                                  sx={{
                                    ml: 2,
                                    fontSize: "12px",
                                  }}
                                >
                                  {item?.part?.description}
                                </Typography>
                              </StyledTableCell>
                            </StyledTableRow>
                          ))
                      : ""}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>
        </Grid>
        {isOpen && (
          <Lightbox mainSrc={URL} onCloseRequest={handleLightBoxClose} />
        )}
        <Dialog
          className="check"
          maxWidth={"lg"}
          open={viewPartOpen}
          fullWidth
          onClose={handleClose}
        >
          <DialogTitle alignSelf={"center"}>Part Detail</DialogTitle>
          <DialogContent>
            <Card style={{ padding: "10px", margin: "10px" }}>
              <Grid container spacing={4} justifyContent="flex-start">
                <Grid item xs={12} md={6} pr={2}>
                  {selectedPart && selectedPart?.images ? (
                    <Carousel width={"100%"}>
                      {selectedPart?.images.map((img: any) => {
                        return (
                          <div
                            onClick={() => {
                              setURL(img?.absoluteUrl ?? "");
                              setOpen(true);
                            }}
                          >
                            <img
                              style={{ width: "100%" }}
                              src={img?.absoluteUrl ?? ""}
                            ></img>
                          </div>
                        );
                      })}
                    </Carousel>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid
                  item
                  mt={4}
                  xs={12}
                  md={6}
                  sx={{
                    border: "1px solid #dee2e6 !important",
                    minHeight: "70vh",
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: 700, textTransform: "uppercase" }}
                  >
                    {selectedPart?.title}
                  </Typography>
                  <Divider />
                  <Typography
                    mt={3}
                    mb={3}
                    sx={{ fontWeight: 700, fontSize: "1.5rem" }}
                  >
                    Part Overview
                  </Typography>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Description
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: selectedPart?.description,
                          }}
                        ></span>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel2a-content"
                      id="panel2a-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Weight & Dimension
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Height</TableCell>
                            <TableCell align="right">Weight</TableCell>
                            <TableCell align="right">Length</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell component="th" scope="row">
                              {selectedPart?.dimension?.height}
                              in
                            </TableCell>
                            <TableCell align="right">
                              {selectedPart?.dimension?.weight}
                              lbs
                            </TableCell>
                            <TableCell align="right">
                              {selectedPart?.dimension?.depth}
                              in
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Accordion>
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel3a-content"
                      id="panel3a-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Specifications
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Table aria-label="customized table">
                        <TableBody>
                          <StyledTableRow>
                            <StyledTableCell component="th">
                              Part Number
                            </StyledTableCell>
                            <StyledTableCell>
                              {selectedPart?.partNumber}
                            </StyledTableCell>
                          </StyledTableRow>

                          <StyledTableRow>
                            <StyledTableCell>Tags</StyledTableCell>
                            <StyledTableCell>
                              {selectedPart?.tags.map((item: any) => (
                                <Chip label={item} />
                              ))}
                            </StyledTableCell>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              </Grid>{" "}
            </Card>
          </DialogContent>
          <DialogActions>
            <Button
              autoFocus
              onClick={() => {
                setViewPartOpen(false);
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default ProductDetailPublicView;
